<template>
  <div class="home">
    <!-- 轮播图 -->
    <van-swipe class="banner" :autoplay="3000" indicator-color="white">
      <van-swipe-item
        v-for="(banner, index) in carouselItems"
        :key="index"
        style="position: relative"
        @click="bannerClick(banner)"
      >
        <img
          :src="banner.pic"
          :alt="banner.descriptions"
          style="object-fit: fill; width: 100%"
        />
        <p
          style="
            padding: 10px;
            color: #fff;
            position: absolute;
            bottom: 0px;
            height: 40px;
            width: 100%;
            background-color: rgba(0, 0, 0, 0.5);
          "
        >
          {{ banner.descriptions }}
        </p>
      </van-swipe-item>
    </van-swipe>

    <van-notice-bar left-icon="volume-o">
      <van-swipe
        class="notice-swipe my-swipe"
        :autoplay="10000"
        indicator-color="white"
        :duration="1000"
      >
        <van-swipe-item
          v-for="(item, index) in noticelItems"
          :key="index"
          @click="noticeClick(item)"
          >{{ item.title }}</van-swipe-item
        >
      </van-swipe>
    </van-notice-bar>
    <van-popup :style="{ width: '100%' }" v-model:show="noticeShow">
      <div v-html="noticeData"></div>
    </van-popup>

    <div class="section-header">
      <span class="title" style="padding-left: 10px;">最新上架</span>
      <span class="view-more" @click="goMarket">查看更多<van-icon name="arrow" /></span>
    </div>
    <div class="container">
      <!-- 最新上架标题 -->

      <!-- 武器商品网格 -->
      <div class="weapon-grid">
        <div
          v-for="weapon in newList"
          :key="weapon.produceId"
          class="weapon-card"
          @click="onWeaponClick(weapon)"
        >
          <!-- 商品图片容器 -->
          <div class="weapon-image-container">
            <img
              :src="weapon.imageUrl"
              :alt="weapon.name"
              class="weapon-image"
            />
            <!-- 左下角图标区域 -->
            <div class="icons-container" v-if="weapon.stickerUrls.length > 0">
              <img
                v-for="(sticker, index) in weapon.stickerUrls.split(',')"
                :key="index"
                :src="sticker"
                :alt="weapon.categoryName"
                class="icon-item"
                :title="weapon.categoryName"
              />
            </div>
            <div class="template-overlay" v-if="weapon.template > 0">
              <div class="template-wrapper">
                <img src="@/assets/template.png" width="30px" height="30px" />
                <span class="template">{{ weapon.template || "0" }}</span>
              </div>
            </div>
          </div>
          <!-- 商品信息 -->
          <div class="weapon-info">
            <div
              style="
                color: black;
                font-size: 12px;
                font-weight: bold;
                margin-bottom: 3px;
              "
            >
              {{ weapon.categoryName }}
            </div>
            <!-- 价格和统计 -->
            <div class="weapon-stats">
              <div class="price-section">
                <span style="color: #ee0a24; font-weight: bold">￥</span>
                <span class="current-price">{{ weapon.price }} </span>
                <img
                  v-if="weapon.isStack == '1'"
                  src="@/assets/st.png"
                  alt="ST"
                  width="26px"
                  height="16px"
                  class="product-sales"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <van-tabbar route :border="false">
      <van-tabbar-item replace to="/" icon="home-o" >首页</van-tabbar-item>
      <van-tabbar-item replace to="/market"  icon="search">市场</van-tabbar-item>

  <van-tabbar-item replace to="/stock" class="sell-button">
    <template #icon>
      <div class="circle-icon">
        <van-icon name="plus" size="24" />
      </div>
    </template>
    <span>卖闲置</span>
  </van-tabbar-item>
      <van-tabbar-item replace to="/proxyPlay"  icon="diamond-o">代充</van-tabbar-item>
      <van-tabbar-item replace to="/profile"  icon="user-o">我的</van-tabbar-item>
    </van-tabbar> -->
    
  </div>
</template>

<script>
import request from "@/utils/request";
import { NoticeBar } from "vant";
export default {
  name: "HomePage",
  data() {
    return {
      tabActive: 0,
      carouselItems: [],
      noticelItems: [],
      // 武器商品数据
      newList: [],
      noticeShow: false,
      noticeData: "",
      savedScrollTop: 0, // 保存容器的滚动位置
    };
  },
  created() {
    //获取喇叭数据内容
    request.get("/front/chat/keywords", { params: { type: 1 } }).then((res) => {
      if (res.code == 200) {
        this.noticelItems = res.data;
        this.noticelItems = this.noticelItems.filter((item) => item.type == 1);
      }
    });

    //轮播图
    //获取动态轮播图
    request.get("/front/poster/list").then((res) => {
      if (res.code == 200) {
        this.carouselItems = res.rows;
      }
    });

    //获取最新上架数据
    request.get("/front/weapon/newList").then((res) => {
      if (res.code == 200) {
        this.newList = res.rows;
        // 数据加载完成后恢复滚动位置
        this.restoreScrollPosition();
      }
    });
  },
  mounted() {
  },
  methods: {
    restoreScrollPosition() {
      this.$nextTick(() => {
        const savedPosition = sessionStorage.getItem('homeContainerScrollTop');
        if (savedPosition) {
          setTimeout(() => {
            const container = this.$el ? this.$el.querySelector('.container') : null;
            if (container) {
              container.scrollTop = parseInt(savedPosition);
            }
          }, 200);
        }
      });
    },
    onWeaponClick(weapon) {
      // 跳转前保存滚动位置
      const container = this.$el ? this.$el.querySelector('.container') : null;
      if (container) {
        sessionStorage.setItem('homeContainerScrollTop', container.scrollTop);
      }
      
      // 跳转到武器详情页
      this.$router.push({
        path: "/weapon/" + new Date().getTime(), // 使用路由名称而非路径
        query: {
          produceId: weapon.productId,
        },
      });
    },
    goMarket() {
this.$router.push("/market");
    },
    extractAndStyleImages(htmlString) {
      // 匹配所有img标签的正则表达式
      const imgRegex = /<img[^>]+src="([^">]+)"[^>]*>/g;
      const images = [];
      let match;

      // 提取所有img标签
      while ((match = imgRegex.exec(htmlString)) !== null) {
        images.push({
          originalTag: match[0], // 原始img标签
          src: match[1], // 图片地址
          index: match.index, // 在字符串中的位置
        });
      }

      return images;
    },
    processHTMLWithStyledImages(htmlString) {
      // 提取所有图片
      const images = this.extractAndStyleImages(htmlString);
      let processedHTML = htmlString;

      // 为每个img标签添加样式
      images.forEach((img) => {
        const styledImgTag = `<img src="${img.src}" style="max-width: 100%; height: auto;" alt="饰品图片">`;
        processedHTML = processedHTML.replace(img.originalTag, styledImgTag);
      });

      return processedHTML;
    },

    noticeClick(data) {
      this.noticeData = data.content;
      this.noticeData = this.processHTMLWithStyledImages(this.noticeData);
      this.noticeShow = true;
    },
    bannerClick(data) {
      if (data.url) {
        window.open(data.url);
      }
    },
  },
};
</script>

<style scoped>
/* 轮播图样式 */
.banner {
  position: relative;
  width: 100%;
  aspect-ratio: 16/9;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  flex-shrink: 0; /* 防止轮播图被压缩 */
  margin-bottom: 0px;
  height: 120px;
}

.banner img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

@media (max-width: 480px) {
  .banner {
    aspect-ratio: 2/1;
  }
}

.home {
  background-color: #f7f8fa;
  height: 100%;
  overflow: hidden; /* 确保整体不滚动 */
  display: flex;
  flex-direction: column;
}

/* 容器样式 */
.container {
  margin-top: 0px;
  padding: 10px;
  overflow-y: auto; /* 只有这个区域可以滚动 */
  flex: 1;
  min-height: 0; /* 重要：确保flex子元素正确计算高度 */
}

/* 轮播图样式 */
.banner {
  position: relative;
  width: 100%;
  aspect-ratio: 16/9;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  flex-shrink: 0; /* 防止轮播图被压缩 */
  margin-bottom: 0px;
}

.banner img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

@media (max-width: 480px) {
  .banner {
    aspect-ratio: 2/1;
  }
}

/* 标题区域 */
.section-header {
  display: flex;
  align-items: center;
  padding: 10px 0;
  flex-shrink: 0; /* 防止标题区域被压缩 */
}

.section-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #323233;
}

.title-box {
  padding-left: 10px;
  display: flex;
  align-items: center;
  flex: 1;
}

.view-more {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #999;
  font-size: 14px;
  margin-left: auto;
  margin-right: 15px;
}

.view-more .van-icon {
  vertical-align: middle;
}

.title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  position: relative;
  display: inline-block;
  padding-bottom: 8px;
}

.title::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: linear-gradient(90deg, #1890ff, #40a9ff);
  border-radius: 1px;
}

/* 武器网格布局 */
.weapon-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}

/* 武器卡片 */
.weapon-card {
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  cursor: pointer;
}

.weapon-card:active {
  transform: scale(0.98);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

/* 图片容器 */
.weapon-image-container {
  position: relative;
  width: 100%;
  height: 80px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.weapon-image {
  width: 90%;
  height: 70%;
  object-fit: contain;
}

/* 左下角图标容器 */
.icons-container {
  position: absolute;
  bottom: 5px;
  left: 5px;
  display: flex;
  gap: 5px;
}

.icon-item {
  width: 16px;
  height: 16px;
  /* background-color: rgba(0, 0, 0, 0.1); */
  /* border-radius: 50%; */
  object-fit: cover;
}

/* 武器信息区域 */
.weapon-info {
  padding: 8px;
}

/* 价格和统计区域 */
.weapon-stats {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

/* 价格区域 */
.price-section {
  display: flex;
  width: 100%;
  /* flex-direction: column; */
  /* align-items: flex-start; */
}

.current-price {
  font-size: 14px;
  font-weight: 600;
  color: #ee0a24;
  flex: 1;
}

/* 统计信息 */
.stats {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.stat-item {
  font-size: 10px;
  color: #969799;
}

/* 响应式优化 */
@media (max-width: 375px) {
  .weapon-grid {
    gap: 8px;
  }

  .current-price {
    font-size: 13px;
  }
}

@media (min-width: 768px) {
  .weapon-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

.van-tabbar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}
.template-overlay {
  position: absolute;
  bottom: 5px;
  left: 10px;
  display: flex;
  align-items: center;
  border-radius: 4px;
}

.template-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
}
.template {
  position: absolute;
  left: 42%;
  top: 70%;
  transform: translate(-50%, -50%);
  color: #eee;
  font-size: 12px;
  font-weight: bold;
  text-shadow: 0 0 2px rgba(0, 0, 0, 0.5);
}

.product-sales {
  margin-left: auto;
}

.notice-swipe {
  height: 40px;
  line-height: 40px;
}

.my-swipe .van-swipe-item {
  text-decoration: underline;
}
</style>